import { Link } from "@tanstack/react-router";
import type { ReactNode } from "react";

import { shopifyOrderAdminUrl } from "../lib/shopifyStore";

/** An order's page in the store's admin, in a new tab; plain text when the handle is unknown. */
export function ShopifyOrderLink({
  shopHandle,
  orderGid,
  className = "hover:underline",
  children,
}: {
  shopHandle: string | null;
  orderGid: string;
  className?: string;
  children: ReactNode;
}) {
  if (!shopHandle) return children;
  return (
    <a
      href={shopifyOrderAdminUrl(shopHandle, orderGid)}
      target="_blank"
      rel="noreferrer"
      className={className}
    >
      {children}
    </a>
  );
}

/** A Shopify sales row's customer, linking to their page; a dash when the row has none. */
export function ShopifyCustomerLink({
  tenantId,
  row,
}: {
  tenantId: string;
  row: {
    endUserId: string | null;
    endUserUsername: string | null;
    endUserExternalId: string | null;
  };
}) {
  if (!row.endUserId) return <span className="text-muted-foreground">—</span>;
  return (
    <Link
      to="/tenants/$tenantId/users/$userId"
      params={{ tenantId, userId: row.endUserId }}
      className="hover:underline"
    >
      {row.endUserUsername ? `@${row.endUserUsername}` : row.endUserExternalId}
    </Link>
  );
}
